import { UseFormReturnType } from '@mantine/form';
import { useMemo } from 'react';

import { TSDViewEditGoodsItemFormValues } from '@e-origin/contracts';
import { DocumentsEnum, TransitDocumentsEnum } from '@e-origin/shared';

import { Documents } from '@components';
import { TSDDocumentFormSchema } from '../../TSDDocumentFormSchema';

interface GoodsItemDocumentsProps {
  goodsItemForm: UseFormReturnType<TSDViewEditGoodsItemFormValues>;
  disabled: boolean;
}

export interface DocumentItemProps {
  type: TransitDocumentsEnum;
  label?: string;
  code: string;
  referenceNumber?: string;
  dateOfValidity?: string;
  dataSource: any;
  dataSourceIndex: number;
}

export const GoodsItemDocuments: React.FC<GoodsItemDocumentsProps> = ({ goodsItemForm, disabled }) => {
  const documentFormSchema = TSDDocumentFormSchema();

  const documents = useMemo(
    () => ({
      previousDocuments: [...goodsItemForm.values.previousDocuments],
      additionalInformation: [...goodsItemForm.values.additionalInformation],
      supportingDocuments: [...goodsItemForm.values.supportingDocuments],
      additionalReference: [...goodsItemForm.values.additionalReference],
    }),
    [goodsItemForm.values],
  );

  const handleDocumentDelete = (documentType: any, documentIndex: number) => {
    goodsItemForm.setFieldValue(`${documentType}`, [...(goodsItemForm.values[documentType] || []).filter((_, idx) => idx !== documentIndex)]);
  };

  const handleSavingDocument = (savedDocument) => {
    if (savedDocument.docIndex >= 0) {
      const updatedDocuments = goodsItemForm.values[savedDocument.type].map((doc, idx) => {
        if (idx === savedDocument.docIndex) {
          return savedDocument.data;
        }
        return doc;
      });
      goodsItemForm.setFieldValue(`${savedDocument.type}`, updatedDocuments);
    } else {
      goodsItemForm.setFieldValue(`${savedDocument.type}`, [...(goodsItemForm.values[savedDocument.type] || []), savedDocument.data]);
    }
  };

  return (
    <Documents
      disabledDocuments={[DocumentsEnum.TRANSPORT_DOCUMENTS]}
      documents={documents}
      onDelete={handleDocumentDelete}
      onSave={handleSavingDocument}
      disabled={disabled}
      documentFormSchema={documentFormSchema}
    />
  );
};
